export const listsName = [
  {
    name: 'Skills',
    route: 'skill',
  },
  {
    name: 'Energy level',
    route: 'energy-level',
  },
  {
    name: 'Grades',
    route: 'grade',
  },
  {
    name: 'Relations',
    route: 'relation',
  },
  {
    name: 'League Sports',
    route: 'league-sport',
  },
  {
    name: 'Event Category',
    route: 'event-category',
  },
  {
    name: 'Activity Category',
    route: 'activity-category',
  },
  {
    name: 'Colors',
    route: 'colors',
  },
  {
    name: 'Goal',
    route: 'goal',
  },
  {
    name: "Highlighted Element's",
    route: 'highlighted-element',
  },
  {
    name: 'Age group',
    route: 'age-group',
  },
  {
    name: 'Items to bring',
    route: 'item-to-bring',
  },
  {
    name: 'Amenities',
    route: 'amenities',
  },
]

export const hasCustomIcon = ['item-to-bring', 'allergy']
